<template>
  <div class="assessment">
    <div class="assessment-histogram"></div>
    <div class="assessment-time">
      <p>
        <span>今日学习时长：</span>
        <span>{{msg.Todaytime}}秒</span>
      </p>
      <p>
        <span>总学习时长：</span>
        <span>{{msg.sumtime}}秒</span>
      </p>
    </div>
    <div class="assessment-title">近七天学习记录</div>
    <div class="assessment-box">
      <textTem v-for="(data,i) in msg.historyArr" :key="i" :msg="data" />
    </div>
  </div>
</template>
<script>
import textTem from "../component/textTem";
export default {
  data() {
    return {
      echarts: require("echarts"),
      // msg: {
      //   imgUrl: "20200426092657-640_看图王.web.jpg",
      //   title: "依法治国与坚持中国特色社会主义道路。",
      //   time: "时间：2019.09.13"
      // },
      msg: {
        date: [],
        data: [],
        sumtime: "",
        Todaytime: "",
        historyArr: []
      }
    };
  },
  mounted() {
    // console.log(this.echarts);
    this.getMsg();
  },
  methods: {
    histInit(msg) {
      let myChart = this.echarts.init(
        document.querySelector(".assessment-histogram")
      );

      let option = {
        title: [
          {
            text: "学习评估",
            textStyle: {
              color: "#fff"
            },
            top: 10,
            left: 10
          },
          {
            text: "最近七天丨单位：秒",
            textStyle: {
              color: "#fff",
              fontSize: "12"
            },
            top: 30,
            left: 10
          }
        ],

        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: 80,
          left: 50,
          right: 40,
          bottom: 30
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: msg.date,
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          }
        },
        series: [
          {
            name: "学习时长",
            data: msg.data,
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#fff"
            }
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    getMsg() {
      // , {params: {userid: sessionStorage.getItem("userid")}}

      this.axios
        .get(
          `api/Index/GetLearningrecord?userid=${sessionStorage.getItem("id")}`
        )
        .then(res => {
          if (res.data.code == 0) {
            // console.log(res.data);
            this.msg.sumtime = res.data.sumtime;
            this.msg.Todaytime = res.data.Todaytime;
            this.msg.historyArr = res.data.History;

            res.data.msg.filter(item => {
              this.msg.date.push(item.xuexidate.split(" ")[0]);
              this.msg.data.push(item.xuexitime);
            });
            this.histInit(this.msg);
            console.log(this.msg.historyArr);
          }
        });
    }
  },
  components: {
    textTem
  }
};
</script>
<style lang='scss' scoped>
.assessment {
  &-box {
    padding: 0 0.2rem;
  }
  &-title {
    padding: 0.2rem;
  }
  &-time {
    p {
      span {
        &:nth-child(1) {
          display: inline-block;
          width: 40%;
        }
      }
      background: #fff;
      padding: 0.3rem;
      border-bottom: 0.01rem solid #e6e6e6;
    }
  }
  &-histogram {
    width: 100%;
    height: 5.5rem;
    background: linear-gradient(
      101deg,
      rgba(251, 115, 61, 1) 0%,
      rgba(255, 58, 58, 1) 100%
    );
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>
